module.exports = __webpack_public_path__ + "static/media/mywallet.94128f74.png";